import type { VariantProps } from "tailwind-variants";
import { tv } from "tailwind-variants";

import type { SvgSlot } from "@/shared/ui/common";

const styles = tv({
  base: "rounded-full bg-primary-50 text-secondary-400",
  variants: {
    color: {
      error: "bg-red-100 text-red-500",
      warning: "bg-yellow-100 text-yellow-600",
      success: "bg-green-100 text-green-500",
      gray: "bg-neutral-100 text-neutral-500",
    },
    size: {
      xs: "size-6 p-1",
      sm: "size-10 p-2",
      md: "size-14 p-2.5",
      lg: "size-14 p-2.5 sm:size-20 sm:p-4.5",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

type Props = VariantProps<typeof styles> & {
  icon: typeof SvgSlot;
};

export const CircleIcon = ({ icon: Icon, ...props }: Props) => {
  return (
    <span aria-hidden className={styles(props)} {...props}>
      <Icon />
    </span>
  );
};
